import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sammi/logo-white.png")